<div class="flex h-full flex-col">
  <div class="header relative p-3">
    <div class="title text-center text-lg">Edit Address</div>
    <button
      type="button"
      class="close absolute top-[50%] right-3 -translate-y-[50%]"
      (click)="onClose()">
      <fa-icon [icon]="faTimes"></fa-icon>
    </button>
  </div>
  <div class="flex-1 space-y-3 overflow-y-auto p-3">
    <form
      class="address-form"
      [formGroup]="addressForm"
      (ngSubmit)="onSubmit()"
      *ngIf="addressForm">
      <div class="grid gap-3 lg:grid-cols-2">
        <div class="form-group relative">
          <input
            type="text"
            #receiverName
            placeholder="Recipient's name"
            class="relative w-full rounded-md border border-primary-dark px-3 py-2 text-primary-darkest outline-none"
            formControlName="receiver_name" />
          <label
            for="receiver_name"
            *ngIf="receiverName.value"
            class="absolute left-2 -top-2 bg-white px-1 text-xs text-primary-md-dark opacity-100"
            >Recipient's name</label
          >
        </div>
        <div class="form-group relative">
          <input
            type="text"
            #phoneNo
            placeholder="Phone Number"
            class="relative w-full rounded-md border border-primary-dark px-3 py-2 text-primary-darkest outline-none"
            formControlName="phone_no" />
          <label
            for="phoneNo"
            *ngIf="phoneNo.value"
            class="absolute left-2 -top-2 bg-white px-1 text-xs text-primary-md-dark opacity-100"
            >Phone Number</label
          >
        </div>
      </div>
      <div class="mt-3 space-y-3">
        <div class="form-group relative">
          <input
            type="text"
            #postalCode
            placeholder="Postal Code"
            class="relative w-full rounded-md border border-primary-dark px-3 py-2 text-primary-darkest outline-none"
            formControlName="postal_code" />
          <label
            for="phoneNo"
            *ngIf="postalCode.value"
            class="absolute left-2 -top-2 bg-white px-1 text-xs text-primary-md-dark opacity-100">
            Postal Code
          </label>
        </div>
        <div class="p-input-wrapper relative">
          <textarea
            #address
            class="mt-2 w-full rounded-md border border-primary-dark px-3 py-2 text-primary-darkest outline-none"
            placeholder="Address"
            id="address"
            placeholder="Address"
            formControlName="address"
            rows="4"></textarea>
          <label
            for="address"
            *ngIf="address.value"
            class="absolute left-2 top-0 bg-white px-1 text-xs text-primary-md-dark opacity-100">
            Address
          </label>
        </div>
        <div class="form-group relative">
          <input
            type="note"
            #note
            placeholder="Note"
            class="relative w-full rounded-md border border-primary-dark px-3 py-2 text-primary-darkest outline-none"
            formControlName="note" />
          <label
            for="note"
            *ngIf="note.value"
            class="absolute left-2 -top-2 bg-white px-1 text-xs text-primary-md-dark opacity-100">
            Note
          </label>
        </div>
      </div>
      <div class="mt-3 flex items-center justify-end gap-3">
        <button
          type="button"
          class="rounded-md border border-primary-darkest py-1 px-3 text-primary-darkest"
          (click)="onClose()">
          Cancel
        </button>
        <button
          type="submit"
          class="flex items-center gap-1 rounded-md border bg-primary-darkest py-1 px-3 text-white"
          [disabled]="loading"
          [ngClass]="{ 'opacity-25': loading }">
          <span class="btn-label">Edit Address</span>
          <fa-icon
            *ngIf="loading"
            class="load-icon"
            [icon]="faSpinner"
            [spin]="true"></fa-icon>
        </button>
      </div>
    </form>
  </div>
</div>
